var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse"},[_c('transition',{attrs:{"name":"accordion"},on:{"enter":_vm.start,"after-enter":_vm.end,"before-leave":_vm.start,"after-leave":_vm.end}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }